<template>
  <div>
    <DynamicModal
      :showModal="showModalProp"
      :persistent="false"
      @clickOutside="closeModal"
      title="Edit Total Pay"
      maxWidth="500px"
    >
      <v-container fluid slot="title-buttons" class="py-1">
        <v-row justify="end">
          <v-btn
            icon
            depressed
            color="primary"
            @click="closeModal"
          >
            <v-icon color="white">close</v-icon>
          </v-btn>
        </v-row>
      </v-container>
      <v-container fluid slot="content">
        <v-form ref="form" lazy-validation>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-text-field
                label="Period"
                v-model="period"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Internal Employee"
                v-model="employeeName"
                readonly
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" >
              <FormattedNumberField
                label="Current Total Pay"
                :value="totalPay"
                :readonly="true"
                prepend-inner-icon="attach_money"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="12" sm="6">
              <FormattedNumberField
                label="New Total Pay"
                :value="newTotalPay"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.newTotalPay = newValue"
              ></FormattedNumberField>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                label="Details"
                v-model="details"
                textarea
                outlined
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-container fluid slot="buttons" class="pb-0 mb-0">
        <div class="row d-flex justify-end">
          <div class="col-6">
            <v-btn
              block
              depressed
              color="primary"
              @click="editTotalPay"
            >
              Save
            </v-btn>
          </div>
          <div class="col-6">
            <v-btn
              block
              depressed
              outlined
              @click="closeModal"
            >
              Cancel
            </v-btn>
          </div>
        </div>
      </v-container>
    </DynamicModal>
  </div>
</template>

<script>
import { DynamicModal } from '@/components/dialogs'
import { mapActions } from 'vuex'
import { FormattedNumberField } from '@/components/shared/textFields'
import formatDate from '@/lib/display/formatDate'
import { nextTick } from 'vue'

export default {
  components: {
    DynamicModal,
    FormattedNumberField
  },
  props: [
    'dateBegin',
    'dateEnd',
    'staffId',
    'employeeName',
    'totalPay',
    'totalPayEditedId'
  ],
  data () {
    return {
      showModalProp: false,
      newTotalPay: null,
      details: null
    }
  },
  computed: {
    period () {
      return formatDate(this.dateBegin) + ' - ' + formatDate(this.dateEnd)
    }
  },
  methods: {
    ...mapActions('staffEditedTotalPay', [
      'getStaffEditedTotalPay',
      'saveStaffEditedTotalPay',
      'updateStaffEditedTotalPay'
    ]),
    clearModal () {
      this.newTotalPay = null
      this.details = null
    },
    async showModal () {
      this.clearModal()
      await nextTick()
      if (this.totalPayEditedId) {
        let editedTotalPay = await this.getStaffEditedTotalPay({ id: this.totalPayEditedId })
        this.details = editedTotalPay.details
      }
      this.showModalProp = true
    },
    closeModal () {
      this.showModalProp = false
      this.clearModal()
      this.$emit('closeModal')
    },
    async editTotalPay () {
      if (this.$refs.form.validate()) {
        let editedTotalPay = {
          id: this.totalPayEditedId,
          dateBegin: this.dateBegin,
          dateEnd: this.dateEnd,
          staffId: this.staffId,
          totalPay: this.newTotalPay,
          details: this.details
        }
        if (this.totalPayEditedId) {
          await this.updateStaffEditedTotalPay(editedTotalPay)
        } else {
          await this.saveStaffEditedTotalPay(editedTotalPay)
        }
        this.closeModal()
        this.$emit('editedTotalPay')
        this.newTotalPay = null
        this.details = null
      }
    }
  }
}
</script>
